"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledButtonGroup = exports.StyledButton = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _helpers = require("../utils/helpers");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _templateObject29() {
  var data = _taggedTemplateLiteral(["\n  display: inline-flex;\n  justify-content: space-between;\n"]);

  _templateObject29 = function _templateObject29() {
    return data;
  };

  return data;
}

function _templateObject28() {
  var data = _taggedTemplateLiteral(["\n      border-radius: 0;\n    "]);

  _templateObject28 = function _templateObject28() {
    return data;
  };

  return data;
}

function _templateObject27() {
  var data = _taggedTemplateLiteral(["\n      margin-left: 0;\n    "]);

  _templateObject27 = function _templateObject27() {
    return data;
  };

  return data;
}

function _templateObject26() {
  var data = _taggedTemplateLiteral(["\n          margin-left: 1px;\n\n          &:first-of-type {\n            margin-left: 0;\n          }\n        "]);

  _templateObject26 = function _templateObject26() {
    return data;
  };

  return data;
}

function _templateObject25() {
  var data = _taggedTemplateLiteral(["\n          cursor: default;\n\n          &:hover {\n            background-color: ", ";\n          }\n        "]);

  _templateObject25 = function _templateObject25() {
    return data;
  };

  return data;
}

function _templateObject24() {
  var data = _taggedTemplateLiteral(["\n      margin-left: -1px;\n      border-radius: 0;\n\n      &:first-child {\n        margin-left: 0;\n        border-top-left-radius: ", ";\n        border-bottom-left-radius: ", ";\n      }\n\n      &:last-child {\n        border-top-right-radius: ", ";\n        border-bottom-right-radius: ", ";\n      }\n\n      ", ";\n\n      ", ";\n    "]);

  _templateObject24 = function _templateObject24() {
    return data;
  };

  return data;
}

function _templateObject23() {
  var data = _taggedTemplateLiteral(["\n            color: ", ";\n          "]);

  _templateObject23 = function _templateObject23() {
    return data;
  };

  return data;
}

function _templateObject22() {
  var data = _taggedTemplateLiteral(["\n          color: ", ";\n        "]);

  _templateObject22 = function _templateObject22() {
    return data;
  };

  return data;
}

function _templateObject21() {
  var data = _taggedTemplateLiteral(["\n      background: transparent;\n      color: ", ";\n      border: none;\n      padding: ", ";\n      ", ";\n\n      &:hover {\n        color: ", ";\n        background: transparent;\n        ", ";\n      }\n    "]);

  _templateObject21 = function _templateObject21() {
    return data;
  };

  return data;
}

function _templateObject20() {
  var data = _taggedTemplateLiteral(["\n      color: ", ";\n      background: ", ";\n      border-color: ", ";\n\n      &:hover {\n        color: ", ";\n        background: ", ";\n        border-color: ", ";\n      }\n    "]);

  _templateObject20 = function _templateObject20() {
    return data;
  };

  return data;
}

function _templateObject19() {
  var data = _taggedTemplateLiteral(["\n      color: ", ";\n      background: transparent;\n      border-color: ", ";\n\n      &:hover {\n        color: ", ";\n        background: ", ";\n        border-color: ", ";\n      }\n    "]);

  _templateObject19 = function _templateObject19() {
    return data;
  };

  return data;
}

function _templateObject18() {
  var data = _taggedTemplateLiteral(["\n      width: 50%;\n      text-align: center;\n    "]);

  _templateObject18 = function _templateObject18() {
    return data;
  };

  return data;
}

function _templateObject17() {
  var data = _taggedTemplateLiteral(["\n      width: 100%;\n      text-align: center;\n    "]);

  _templateObject17 = function _templateObject17() {
    return data;
  };

  return data;
}

function _templateObject16() {
  var data = _taggedTemplateLiteral(["\n      font-size: 17px;\n      line-height: 20px;\n      padding: 0.85rem 1.2rem 0.85rem;\n      font-weight: 300;\n    "]);

  _templateObject16 = function _templateObject16() {
    return data;
  };

  return data;
}

function _templateObject15() {
  var data = _taggedTemplateLiteral(["\n      ", ";\n      padding: 0.5rem 1rem 0.5rem;\n    "]);

  _templateObject15 = function _templateObject15() {
    return data;
  };

  return data;
}

function _templateObject14() {
  var data = _taggedTemplateLiteral(["\n      ", ";\n      padding: 0.2325rem 0.675rem;\n    "]);

  _templateObject14 = function _templateObject14() {
    return data;
  };

  return data;
}

function _templateObject13() {
  var data = _taggedTemplateLiteral(["\n      ", ";\n      padding: 0.12rem 0.375rem;\n    "]);

  _templateObject13 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12() {
  var data = _taggedTemplateLiteral(["\n      color: ", ";\n      background: transparent;\n      border-color: ", ";\n      box-shadow: inset 0 0 0 0 ", ";\n\n      &:hover {\n        color: ", ";\n        background: transparent;\n        border-color: ", ";\n        box-shadow: inset 0 0 0 2px ", ";\n      }\n    "]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteral(["\n      background: ", ";\n      color: ", ";\n      border: 1px solid ", ";\n      &:hover {\n        color: ", ";\n        background: ", ";\n      }\n    "]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n      background: none;\n      color: ", ";\n      border: 1px solid ", ";\n      &:hover {\n        color: ", ";\n        background: ", ";\n      }\n    "]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n      background: none;\n      color: ", ";\n      border-color: ", ";\n      &:hover {\n        color: ", ";\n        background: ", ";\n      }\n    "]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n      color: ", ";\n      background: ", ";\n      border-color: ", ";\n\n      &:hover {\n        color: ", ";\n        background: ", ";\n        border-color: ", ";\n      }\n    "]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n      background: none;\n      color: ", ";\n      border: none;\n\n      &:hover {\n        color: ", ";\n        background: none;\n        text-decoration: underline;\n      }\n    "]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n      cursor: not-allowed;\n      pointer-events: none;\n      opacity: 0.3;\n    "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n          border-top-left-radius: 0;\n          border-bottom-left-radius: 0;\n        "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n          border-top-right-radius: 0;\n          border-bottom-right-radius: 0;\n        "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n          background: none;\n          color: ", ";\n          border: none;\n          border-bottom: 1px solid ", ";\n\n          &:hover {\n            color: ", ";\n            background: none;\n            text-decoration: underline;\n          }\n        "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n      margin: ", " 0 0 0;\n\n      ", ";\n\n      ", ";\n\n      ", ";\n    "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: ", " 0.9rem;\n  width: auto;\n  color: ", ";\n  border: 1px solid ", ";\n  border-radius: ", ";\n  background-color: ", ";\n  box-sizing: border-box;\n  transition: all 0.15s ease-in-out;\n  cursor: pointer;\n  white-space: nowrap;\n  ", ";\n  letter-spacing: 0em;\n  font-family: inherit;\n  text-decoration: none;\n\n  &:hover {\n    background-color: ", ";\n    color: ", ";\n  }\n\n  ", ";\n\n  ", ";\n\n  ", ";\n\n  ", ";\n\n  ", ";\n\n  ", ";\n\n  ", ";\n\n  ", ";\n\n  ", ";\n\n  ", ";\n\n  ", ";\n\n  ", ";\n\n  ", ";\n\n  ", ";\n\n  ", ";\n\n  ", ";\n\n  ", ";\n\n  ", ";\n\n  ", ";\n\n  ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledButton = _styledComponents.default.button(_templateObject(), function (props) {
  return (0, _helpers.unitCalc)(props.theme.baseline, 5, '/');
}, function (props) {
  return props.theme.palette.white;
}, function (props) {
  return props.theme.palette.blue;
}, function (props) {
  return props.theme.borderRadius;
}, function (props) {
  return props.theme.palette.blue;
}, (0, _helpers.fontSize)(-1), function (props) {
  return props.theme.palette.darkBlue;
}, function (props) {
  return props.theme.palette.white;
}, function (props) {
  return props.isAdornment && (0, _styledComponents.css)(_templateObject2(), function (props) {
    return (0, _helpers.unitCalc)(props.theme.baseline, 6, '/');
  }, function (props) {
    return props.minimal && (0, _styledComponents.css)(_templateObject3(), function (props) {
      return props.theme.linkColor;
    }, function (props) {
      return props.theme.palette.lighterGray;
    }, function (props) {
      return props.theme.linkHover;
    });
  }, function (props) {
    return props.adornmentDirection === 'left' && (0, _styledComponents.css)(_templateObject4());
  }, function (props) {
    return props.adornmentDirection === 'right' && (0, _styledComponents.css)(_templateObject5());
  });
}, function (props) {
  return props.disabled && (0, _styledComponents.css)(_templateObject6());
}, function (props) {
  return props.transparent && (0, _styledComponents.css)(_templateObject7(), function (props) {
    return props.theme.linkColor;
  }, function (props) {
    return props.theme.linkHover;
  });
}, function (props) {
  return props.clear && (0, _styledComponents.css)(_templateObject8(), function (props) {
    return props.theme.palette.blue;
  }, function (props) {
    return props.theme.palette.white;
  }, function (props) {
    return props.theme.palette.blue;
  }, function (props) {
    return props.theme.palette.white;
  }, function (props) {
    return props.theme.palette.darkBlue;
  }, function (props) {
    return props.theme.palette.darkBlue;
  });
}, function (props) {
  return props.clearGray && (0, _styledComponents.css)(_templateObject9(), function (props) {
    return props.theme.palette.gray;
  }, function (props) {
    return props.theme.palette.gray;
  }, function (props) {
    return props.theme.palette.white;
  }, function (props) {
    return props.theme.palette.darkGray;
  });
}, function (props) {
  return props.clearWhite && (0, _styledComponents.css)(_templateObject10(), function (props) {
    return props.theme.palette.white;
  }, function (props) {
    return props.theme.palette.white;
  }, function (props) {
    return props.theme.palette.gray;
  }, function (props) {
    return props.theme.palette.white;
  });
}, function (props) {
  return props.white && (0, _styledComponents.css)(_templateObject11(), function (props) {
    return props.theme.palette.white;
  }, function (props) {
    return props.theme.palette.offBlack;
  }, function (props) {
    return props.theme.palette.white;
  }, function (props) {
    return props.theme.palette.offBlack;
  }, function (props) {
    return props.theme.palette.lightestGray;
  });
}, function (props) {
  return props.halo && (0, _styledComponents.css)(_templateObject12(), function (props) {
    return props.theme.palette.blue;
  }, function (props) {
    return props.theme.palette.blue;
  }, function (props) {
    return props.theme.palette.blue;
  }, function (props) {
    return props.theme.palette.blue;
  }, function (props) {
    return props.theme.palette.blue;
  }, function (props) {
    return props.theme.palette.blue;
  });
}, function (props) {
  return props.extraSmall && (0, _styledComponents.css)(_templateObject13(), (0, _helpers.fontSize)(-3));
}, function (props) {
  return props.small && (0, _styledComponents.css)(_templateObject14(), (0, _helpers.fontSize)(-2));
}, function (props) {
  return props.large && (0, _styledComponents.css)(_templateObject15(), (0, _helpers.fontSize)(0));
}, function (props) {
  return props.extraLarge && (0, _styledComponents.css)(_templateObject16());
}, function (props) {
  return props.fullWidth && (0, _styledComponents.css)(_templateObject17());
}, function (props) {
  return props.half && (0, _styledComponents.css)(_templateObject18());
}, function (props) {
  return props.red && (0, _styledComponents.css)(_templateObject19(), function (props) {
    return props.theme.palette.red;
  }, function (props) {
    return props.theme.palette.red;
  }, function (props) {
    return props.theme.palette.white;
  }, function (props) {
    return props.theme.palette.darkRed;
  }, function (props) {
    return props.theme.palette.darkRed;
  });
}, function (props) {
  return props.green && (0, _styledComponents.css)(_templateObject20(), function (props) {
    return props.theme.palette.white;
  }, function (props) {
    return props.theme.palette.green;
  }, function (props) {
    return props.theme.palette.green;
  }, function (props) {
    return props.theme.palette.white;
  }, function (props) {
    return props.theme.palette.darkGreen;
  }, function (props) {
    return props.theme.palette.darkGreen;
  });
}, function (props) {
  return props.iconButton && (0, _styledComponents.css)(_templateObject21(), function (props) {
    return props.theme.palette.darkGray;
  }, function (props) {
    return (0, _helpers.unitCalc)(props.theme.baseline, 5, '/');
  }, function (props) {
    return props.white && (0, _styledComponents.css)(_templateObject22(), function (props) {
      return props.theme.palette.white;
    });
  }, function (props) {
    return props.theme.palette.offBlack;
  }, function (props) {
    return props.white && (0, _styledComponents.css)(_templateObject23(), function (props) {
      return props.theme.palette.lightestGray;
    });
  });
}, function (props) {
  return props.grouped && (0, _styledComponents.css)(_templateObject24(), function (props) {
    return props.theme.borderRadius;
  }, function (props) {
    return props.theme.borderRadius;
  }, function (props) {
    return props.theme.borderRadius;
  }, function (props) {
    return props.theme.borderRadius;
  }, function (props) {
    return props.isToggle && !props.clear && (0, _styledComponents.css)(_templateObject25(), function (props) {
      return props.theme.palette.blue;
    });
  }, function (props) {
    return !props.isToggle && !props.clear && (0, _styledComponents.css)(_templateObject26());
  });
}, function (props) {
  return props.grouped && props.half && (0, _styledComponents.css)(_templateObject27());
}, function (props) {
  return props.noBorderRadius && (0, _styledComponents.css)(_templateObject28());
});

exports.StyledButton = StyledButton;

var StyledButtonGroup = _styledComponents.default.nav(_templateObject29());

exports.StyledButtonGroup = StyledButtonGroup;


//////////////////
// WEBPACK FOOTER
// ./node_modules/calcite-react/Button/Button-styled.js
// module id = 680
// module chunks = 0